import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Uso_publicoComponent = /** @class */ (function () {
    function Uso_publicoComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            uso_publico: new FormControl('', Validators.required),
        });
        if (!JSON.parse(localStorage.getItem("uso_publico"))) {
            localStorage.setItem("uso_publico", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("uso_publico"));
            this.form.controls['uso_publico'].setValue(this.rows[0] ? this.rows[0].uso_publico : '');
        }
        this.uso_publico = { uso_publico: '' };
    }
    Uso_publicoComponent.prototype.add_uso_publico = function () {
        localStorage.setItem("uso_publico", JSON.stringify([]));
        this.actualRow = localStorage.getItem("uso_publico");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            uso_publico: this.form.value.uso_publico,
        });
        localStorage.setItem("uso_publico", JSON.stringify(this.rows));
    };
    Uso_publicoComponent.prototype.delete_uso_publico = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("autorizaciones", JSON.stringify(this.rows));
            }
        }
    };
    return Uso_publicoComponent;
}());
export { Uso_publicoComponent };
